const useDynamicSizeKey = (key, options) => {
  const valuesToParse = Object.values(options);
  return [key, ...valuesToParse].filter(Boolean).join(':');
};

export default useDynamicSizeKey;
